import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { Home as HomeIcon, SearchOff as SearchOffIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants';
import ResponsiveButton from '@components/ResponsiveButton';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f7f8fc 0%, #e2e8f0 50%, #d1d8e4 100%)',
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          <SearchOffIcon
            sx={{
              fontSize: 80,
              color: 'primary.main',
              mb: 2,
            }}
          />

          <Typography variant="h4" component="h1" gutterBottom>
            Página não encontrada
          </Typography>

          <Typography variant="body1" color="text.secondary" paragraph>
            A URL que você tentou acessar não existe ou foi removida.
          </Typography>

          <Typography variant="body2" color="text.secondary" paragraph>
            Verifique se o endereço está correto ou volte para a tela inicial do sistema.
          </Typography>

          <ResponsiveButton
            variant="contained"
            icon={<HomeIcon />}
            onClick={() => navigate(ROUTES.APP)}
            mobileIconOnly={false}
            mobileText="Voltar"
            sx={{ mt: 2 }}
          >
            Voltar ao sistema
          </ResponsiveButton>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFound;


